import { action, observable } from 'mobx';
import { MeetingTemplateLink } from '../../../../../api/blueprints/meeting.template.types';

export class MeetingTemplateLinksVM {
    @observable
    private readonly templateLinks: MeetingTemplateLink[] = [];

    constructor(links: MeetingTemplateLink[] = []) {
        this.templateLinks = links;
    }

    public getLinks(): MeetingTemplateLink[] {
        return this.templateLinks;
    }

    @action
    public onAddLink(link: MeetingTemplateLink): void {
        this.templateLinks.push(link);
    }

    @action
    public removeLinkByIndex(index: number): void {
        this.templateLinks.splice(index, 1);
    }
}
